import React from 'react'
import { Container } from 'react-bootstrap'
import '../../style/LandingPageStyle.css'

const About = () => {
  return (
    <Container className='about-container'>
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

        {/* --- INÍCIO DO BLOCO DE AJUDA AZUL --- */}
        <div style={{
            marginTop: "50px",
            backgroundColor: "#e3f2fd",
            color: "#0d47a1",
            padding: "30px",
            marginBottom: "40px",
            borderRadius: "8px",
            borderLeft: "6px solid #1976d2",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            width: "100%",
            boxSizing: "border-box",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}>
            <h3 style={{ 
                margin: "0 0 15px 0", 
                fontSize: "1.3rem", 
                fontWeight: "bold",
                textAlign: "center"
            }}>
                Precisas de ajuda para registar a associação ou submeter um desafio?
            </h3>
            
            <p style={{ margin: "0 0 10px 0", fontSize: "1rem", lineHeight: "1.5" }}>
                Se estás a encontrar dificuldades técnicas ao registar a associação ou ao submeter um desafio na aplicação <strong>E4IU</strong>, temos um formulário alternativo de suporte.
            </p>

            <p style={{ margin: "0 0 10px 0", fontSize: "1rem", lineHeight: "1.5" }}>
                Através deste formulário, podes enviar-nos os dados essenciais do desafio e a equipa Engenheiros4IU entrará em contacto contigo para:
            </p>

            <ul style={{ margin: "0 0 15px 20px", padding: "0", fontSize: "1rem", lineHeight: "1.5" }}>
                <li>prestar apoio técnico;</li>
                <li>esclarecer eventuais dúvidas;</li>
                <li>ou inserir manualmente o desafio na plataforma, caso necessário.</li>
            </ul>

            <p style={{ margin: "0 0 20px 0", fontSize: "1rem", lineHeight: "1.5", fontStyle: "italic" }}>
                O nosso objetivo é garantir que nenhuma necessidade fica por registar por motivos técnicos.
            </p>

            <div style={{ textAlign: "center" }}>
                <a 
                    href="https://docs.google.com/forms/d/e/1FAIpQLSenFIh8m0EZMvzcnQW0JLZwftRtPyjfzJXBGQKceYCtOfFtAg/viewform?usp=header" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                        display: "inline-block",
                        backgroundColor: "#1976d2",
                        color: "#ffffff",
                        padding: "12px 28px",
                        fontWeight: "bold",
                        textDecoration: "none",
                        borderRadius: "4px",
                        fontSize: "1rem",
                        transition: "background-color 0.3s"
                    }}
                >
                    Preencher Formulário de Suporte
                </a>
            </div>
        </div>
        {/* --- FIM DO BLOCO DE AJUDA --- */}

        <p className="sobre-bottom-text">Bem-vindo ao Engenheiros4IU, uma plataforma que permite o encontro de engenheiros e estudantes de engenharia com vontade de resolver problemas com associações e entidades.
        </p>

      </div>
    </Container>
  )
}

export default About
